/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
import { useEffect, useRef, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Alert, Box, Button, Grid, Icon, IconButton, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextField, VForm, useVForm, VTextFieldData, AutoCompleteParceiro, IVFormErrors, AutoCompletePlanoDeContas, VFieldMoneyNumber2, VFieldMoneyNumber4dn, VFieldMoney4, AutoCompleteVendedor } from '../../../shared/forms';
import { LayoutBaseDePaginaNfe } from '../../../shared/layouts';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { DialogVenda } from './DialogVenda';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { jwtDecode } from 'jwt-decode';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { VendasService } from '../../../shared/services/api/estoque/venda/venda';
import { vendaFrontOffline } from '../../../shared/offline/vendaOffline';
import { SeletorModoBusca } from '../../../shared/offline/SeletorModoBusca';
import { buscarVendaNaFila, inscreverFila, IItemFila } from '../../../shared/offline/fila';
import { trabalhandoOffline } from '../../../shared/offline/servico';
import { AutoCompleteOperacoes } from '../../../shared/forms/AutoCompleteOperacoes';
import { DialogFaturamento } from './DialogFaturamento';
import { EstoqueOperacoesService } from '../../../shared/services/api/estoque/estoqueOperacoes/EstoqueOperacoesService';
import { ProdutosService, IItemSemEstoque } from '../../../shared/services/api/estoque/produtos/ProdutosService';
import { alpha, styled } from '@mui/material/styles';
import { Environment } from '../../../shared/environment';
import PDFVenda01 from './impressaovenda01';
import PDFVenda02 from './impressaovenda';
import PDFORCAMENTO from './impressaoorcamento';
import { gerarCarne, IDadosCarne } from './impressaocarne';
import { ContasReceberService } from '../../../shared/services/api/Financeiro/ContasReceber';
import { ParceirosService } from '../../../shared/services/api/cadastros/ParceirosService';
import { getAuth } from './../../../GlobalDecode';
import { FerramentasDeDetalheVenda, CartaoFlutuanteCarregando } from '../../../shared/components';
import { useBloqueioSalvamento } from '../../../shared/hooks';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import PrintIcon from '@mui/icons-material/Print';
import { DialogVendaEdit } from './DialogEdit';

// Operações permitidas nesta tela — só as 3 usadas numa venda manual (Venda à Vista, Venda à
// Prazo, Orçamento); as demais (entrada, ajuste de estoque, PIX/Cartão avulsos etc.) não devem
// aparecer aqui, mesmo tendo o mesmo tipo=1. Environment.URL_IDVENDA não é usado pra Venda à
// Vista — aponta pra um id que não existe mais no banco (confirmado ao vivo); o id correto é
// fixo em todo tenant (mesma convenção de Environment.URL_IDVENDAPRAZO/URL_IDORCAMENTO abaixo).
const ID_VENDA_A_VISTA = 'bde2d0c0-df22-4603-b7fe-cb4eace1c63e';
const OPERACOES_PERMITIDAS_VENDA = [ID_VENDA_A_VISTA, Environment.URL_IDVENDAPRAZO, Environment.URL_IDORCAMENTO];
// As duas que exigem estoque de verdade — Orçamento não move estoque, então fica de fora.
const OPERACOES_DE_VENDA_REAL = [ID_VENDA_A_VISTA, Environment.URL_IDVENDAPRAZO];

interface IFormData {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  numero: string;
  idoperacao: string;
  emissao: string;
  vprod: number;
  desconto: number;
  total: number;
  acrescimo: number;
  obs?: string;
}
interface IFormDataGetByIdDevolucao {
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  iduser: string;
  numero: string;
  emissao: string;
  vprod: number;
  desconto: number;
  faturado: boolean;
  total: number;
  acrescimo: number;
  obs?: string;
  status?: 'cancelada' | 'devolvida';
  statusem?: string;
}
interface IFormDataGetByIddevolucao {
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  iduser: string;
  emissao: string;
  dataoperacao: string;
  vprod: number;
  desconto: number;
  faturado: boolean;
  total: number;
  acrescimo: number;
  numero: string;  // Adicione esta linha
  obs?: string;
}
interface IitensEntradaDialog {
  iditens: string;
  idprodutos: string;
  idref: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  ean?: string;
  localizado?: string;
  original?: boolean;
  filtro: string;
  referencia?: string;
  desconto: number;
  voutros: number;
  subtotal: number
  total: number;
  marca?: string;
  status?: number;
  descricao: string;
  deletado?: boolean;
  iditensOriginal?: string;
}
interface IItensidsDevolucao {
  iditens: string;
  idmov: string;
  idprodutos: string;
  un: string;
  qtde: number;
  qtds: number;
  total: number;
  tipo: number;
  idref: string;
  preco: number;
  descricao?: string;
  iditensOriginal?: string;
}
interface JwtPayload {
  idempresa: string;
  iduser: string;
  tipoimp: number;
  refs: boolean;
  img: string;
  decimais: number;
}
interface IItensids {
  iditens: string;
}
dayjs.extend(utc);
dayjs.extend(timezone);

const LIMITE_OBS = 200;

// Formas de pagamento à vista fixas, mesmo padrão do PDV (Dialogvenda.tsx) —
// cada uma já atrelada ao id de operação configurado no Environment, sem
// busca dinâmica.
const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'faturado' | 'idmov'>> = yup.object().shape({
  idparceiro: yup.string().required(),
  idplanoconta: yup.string().required(),
  idoperacao: yup.string().required(),
  numero: yup.string().optional().default(''),
  emissao: yup
    .string()
    .required('O campo é obrigatório')
    .test('valid-date', 'Selecione uma data válida', function (value) {
      if (!value) return false;

      const dateValue = dayjs(new Date(value));

      return dateValue.isValid();
    }),
  vprod: yup.number().required().moreThan(0),
  desconto: yup.number().required(),
  total: yup.number().required().moreThan(0),
  acrescimo: yup.number().required(),
  obs: yup.string().optional().max(LIMITE_OBS),
});

const SectionBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderRadius: 12,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
}));

const destaqueCampoSx = (theme: any) => ({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.text.primary,
    fontSize: '1rem',
    fontWeight: 800,
    textRendering: 'optimizeLegibility',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.04)
      : alpha(theme.palette.common.black, 0.03),
  },
  '& .MuiInputLabel-root': {
    fontWeight: 500,
  },
});

const numeroCampoSx = (theme: any) => ({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.mode === 'dark'
      ? theme.palette.primary.light
      : theme.palette.primary.dark,
    fontSize: '1.05rem',
    fontWeight: 900,
    textRendering: 'optimizeLegibility',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.08),
    '& fieldset': {
      borderColor: alpha(theme.palette.primary.main, 0.4),
    },
  },
  '& .MuiInputLabel-root': {
    fontWeight: 600,
  },
});

const totalCampoSx = (theme: any) => ({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.success.main,
    fontSize: '1rem',
    fontWeight: 800,
    textRendering: 'optimizeLegibility',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.16 : 0.08),
    '& fieldset': {
      borderColor: alpha(theme.palette.success.main, 0.4),
    },
  },
  '& .MuiInputLabel-root': {
    fontWeight: 600,
  },
});

export const DetalheDeVenda: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  // Celular (< 600px): itens em cartões e os campos de valores depois dos
  // itens (ver itensCartoes/camposValores no JSX).
  const smDown = useMediaQuery((t: Theme) => t.breakpoints.down('sm'));
  // Venda ainda não enviada ao servidor (está na fila offline deste
  // computador) — mostra o aviso no topo do formulário. Acompanha a fila:
  // quando a sincronização envia a venda, o aviso some sozinho.
  const [vendaNaFila, setVendaNaFila] = useState<IItemFila | undefined>(undefined);
  useEffect(() => {
    if (id === 'novo') { setVendaNaFila(undefined); return; }
    let cancelado = false;
    const atualizar = () => {
      buscarVendaNaFila(id)
        .then((item) => { if (!cancelado) setVendaNaFila(item?.tipo === 'vendafront' ? item : undefined); })
        .catch(() => { if (!cancelado) setVendaNaFila(undefined); });
    };
    atualizar();
    const cancelarInscricao = inscreverFila(atualizar);
    return () => { cancelado = true; cancelarInscricao(); };
  }, [id]);
  const navigate = useNavigate();
  const location = useLocation();
  const voltarParaListagem = (location.state as { from?: string } | null)?.from || '/venda';
  const { formRef, save, saveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  // Separado de isLoading porque isLoading é reaproveitado em vários outros fluxos
  // (salvar, devolução, faturamento) só para desabilitar botões/campos — usar ele aqui
  // faria o card de carregamento aparecer nesses outros momentos também. Este só liga
  // nos dois pontos em que a venda é (re)carregada do servidor.
  const [carregandoVenda, setCarregandoVenda] = useState(false);
  const { isSaving, iniciar: iniciarSalvamento, concluir: concluirSalvamento, cancelar: cancelarSalvamento } = useBloqueioSalvamento();
  const [mensagemBloqueio, setMensagemBloqueio] = useState('Salvando...');
  const [modoDevolucaoAtivo, setModoDevolucaoAtivo] = useState(false);
  const [openNovo, setOpenNovo] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openFaturamento, setOpenFaturamento] = useState(false);
  const [statuss, setStatuss] = useState(false);
  // Cancelamento/devolução — tanto pelo PDV (EstornarVendaPdv.ts) quanto por
  // aqui mesmo (Cancelar.ts, backend) — a venda nunca é apagada, só
  // marcada. Travada = `statuss` forçado pra true (reaproveita toda a
  // trava de edição que já existe pra venda faturada: sem Salvar, sem
  // Adicionar Item) + some com Cancelar/Devolução/editar-item/remover-item,
  // que continuariam aparecendo só por `statuss===true` normalmente.
  const [vendaStatus, setVendaStatus] = useState<'cancelada' | 'devolvida' | undefined>(undefined);
  const vendaBloqueada = !!vendaStatus;
  // À vista (tpag===1): trava assim que o caixa recebe o pagamento (result.faturado —
  // `result.caixa` foi descartado porque conta até linha revertida, travando pra sempre; ver
  // comentário original no efeito de carregamento). A prazo (qualquer outro tpag): o
  // pagamento não é imediato no caixa, então a venda só trava quando alguma parcela já foi
  // efetivamente recebida em contas a receber (`recebidas !== "0"`) — antes disso ela precisa
  // continuar editável, mesmo já faturada/com duplicatas geradas.
  // `recebidas` vem como texto do servidor ("0") mas como número (0) da venda
  // salva offline (ver vendaOffline.ts) — comparar como número, senão venda a
  // prazo offline travava (0 !== '0') e ficava sem o botão Salvar.
  const calcularStatuss = (faturado: boolean, recebidas: string | number, tpagValor: number | undefined): boolean => {
    if (tpagValor === 1) {
      return faturado !== false;
    }
    return Number(recebidas || 0) > 0;
  };
  const [iditens, setIditens] = useState('');
  const [iditem, setIditem] = useState('');
  const [rows, setRows] = useState<IitensEntradaDialog[]>([]);
  const [rowsids, setRowsids] = useState<IItensids[]>([]);
  const [rowsidsDevolucao, setRowsidsDevolucao] = useState<IItensidsDevolucao[]>([]);
  const [dadositens, setDadositens] = useState<IitensEntradaDialog>();
  const guuid = uuidv4();
  const [faturamento, setFaturamento] = useState<boolean>();
  const [faturamentoDevolucao, setFaturamentoDevolucao] = useState<boolean>();
  const [venda, setvenda] = useState<boolean>();
  const [cabecalho, setCabecalho] = useState<IFormData>();
  const [operacao, setOperacao] = useState<string>();
  const [tpag, setTpag] = useState<number>();
  // idoperacao (não só o texto, ver `operacao` acima) da operação selecionada agora — usado
  // pra saber se é Orçamento (permite item sem estoque) e pra disparar a conferência de
  // estoque quando o operador troca pra Venda à Vista/Prazo (ver efeito mais abaixo).
  const [idOperacaoAtual, setIdOperacaoAtual] = useState<string>();
  // Lista de itens sem estoque suficiente encontrada ao trocar pra uma operação de venda de
  // verdade — não-nula abre o dialog de aviso (ver Dialog "Itens sem estoque" mais abaixo).
  const [itensSemEstoque, setItensSemEstoque] = useState<IItemSemEstoque[] | null>(null);
  const [verificandoEstoque, setVerificandoEstoque] = useState(false);

  const [obsCount, setObsCount] = useState(0);
  const [dadosOriginais, setDadosOriginais] = useState<IFormDataGetByIdDevolucao | null>(null);
  const [openConfirmDevolucao, setOpenConfirmDevolucao] = useState(false);
  const [openmsg, setOpenmsg] = useState(false);
  const [openConfirmFinalizar, setOpenConfirmFinalizar] = useState(false);
  // Junto aos outros estados no topo do componente

  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openConfirmCancelDevolucao, setOpenConfirmCancelDevolucao] = useState(false);
  const [openConfirmItem, setOpenConfirmItem] = useState(false);
  const [openPdfViewer, setOpenPdfViewer] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [isGeneratingCarne, setIsGeneratingCarne] = useState(false);
  const auth = getAuth();
  const tipoimp = auth?.tipoimp ?? 1;
  const refs = auth?.refs;
  const decimais = auth?.decimais ?? 2;
  const margem = auth?.margem ?? 10;
  const est = auth?.est ?? false;

  const tabelaItensRef = useRef<HTMLDivElement>(null);
  const ALTURA_TABELA_ITENS = 260;
  const [densidadeTabela, setDensidadeTabela] = useState({
    rowPy: 0.5,
    rowFontSize: 0.95,
    headerPy: 0.5,
    headerFontSize: 0.75,
    cellPx: 1,
    descricaoMaxWidth: 220,
    refMaxWidth: 120,
  });

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);

  };
  // Venda cancelada/devolvida (vendaBloqueada) não apaga, não cancela de
  // novo nem remove item — só visualização (os botões já ficam escondidos,
  // isso é reforço caso algo ainda chame esses handlers diretamente).
  const handleDelete = () => {
    if (vendaBloqueada) return;
    setOpenConfirm(true);
  };
  const handleDeleteDevolucao = () => {
    if (vendaBloqueada) return;
    setOpenConfirmCancelDevolucao(true);
  };
  const handleDeleteItem = (idi: string) => {
    if (vendaBloqueada) return;
    setOpenConfirmItem(true);
    setIditem(idi);
  };
  const handleItens = (itemEditado: IitensEntradaDialog) => {
    setRows(prevRows => {
      const novosItens = prevRows.map(item =>
        item.iditens === itemEditado.iditens
          ? itemEditado
          : item
      );

      return recalcularTotais(novosItens);
    });

    setOpenEdit(false);
  };
  const handleConfirmDelete = () => {
    if (!iniciarSalvamento()) return;
    setMensagemBloqueio('Excluindo venda...');
    setOpenConfirm(false);

    VendasService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          cancelarSalvamento();
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          concluirSalvamento();
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
          navigate(voltarParaListagem);
        }
      });
  };



  const handleConfirmDeleteItem = () => {
    setRows(prevRows => {
      const itemRemovido = prevRows.find(
        item => item.iditens === iditem
      );

      if (itemRemovido) {
        setRowsids(prev => [
          ...prev,
          { iditens: itemRemovido.iditens }
        ]);
        setRowsidsDevolucao(prev => [
          ...prev,
          {
            iditens: itemRemovido.iditens,
            idmov: id,
            idprodutos: itemRemovido.idprodutos,
            un: itemRemovido.un,
            qtde: 0,
            qtds: itemRemovido.qtds,
            desconto: itemRemovido.desconto,
            subtotal: itemRemovido.subtotal,
            voutros: itemRemovido.voutros,
            total: itemRemovido.total,
            tipo: 2,
            idref: itemRemovido.idref,
            preco: itemRemovido.preco,
            descricao: itemRemovido.descricao || '',
          }
        ]);
      }

      const novasRows = prevRows.map(item =>
        item.iditens === iditem ? { ...item, deletado: true } : item
      );

      return recalcularTotais(novasRows);
    });

    setOpenConfirmItem(false);
  };



  const handleConfirmDeleteDevolucao = () => {
    if (!iniciarSalvamento()) return;
    setMensagemBloqueio('Cancelando venda...');
    setOpenConfirmCancelDevolucao(false);

    VendasService.deleteByIdDevolucao(id)
      .then(result => {
        if (result instanceof Error) {
          cancelarSalvamento();
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          concluirSalvamento();
          setTms('success');
          setMsg('Devolução com sucesso!');
          setOpenmsg(true);
          navigate(voltarParaListagem);
        }
      });
  };
  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };
  const handleCancelDeleteDevolucao = () => {
    setOpenConfirmCancelDevolucao(false);
  };
  const handleCancelDeleteItem = () => {
    setOpenConfirmItem(false);
  };
  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      setCarregandoVenda(true);
      VendasService.getById(id)
        .then((result) => {
          if (result instanceof Error) {
            setIsLoading(false);
            setCarregandoVenda(false);
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
            return;
          }

          setDadosOriginais(result);
          formRef.current?.setData(result);
          // formRef.setData não passa por onIdOperacaoChange (isso só dispara na troca feita
          // pelo próprio operador na Autocomplete) — sem isto, uma venda carregada já como
          // Orçamento ficaria com idOperacaoAtual undefined, e permitirSemEstoque no
          // DialogVenda ficaria errado (false) até o operador mexer no campo manualmente.
          setIdOperacaoAtual(result.idoperacao);
          setObsCount(((result as any).obs || '').length);
          setRows(
            result.itens.map((item: IitensEntradaDialog) => ({
              ...item,
              status: 1,
            }))
          );
          const vprod = result.vprod || 0;
          const desconto = result.desconto || 0;
          const acrescimo = result.acrescimo || 0;
          if (vprod > 0) {
            const percDesconto = Number(((desconto / vprod) * 100).toFixed(4));
            const percAcrescimo = Number(((acrescimo / vprod) * 100).toFixed(4));
            formRef.current?.setFieldValue('descontopercentual', percDesconto);
            formRef.current?.setFieldValue('acrescimopercentual', percAcrescimo);
          }
          EstoqueOperacoesService.getById(result.idoperacao)
            .then((result2) => {
              if (result2 instanceof Error) {
                setTms('error');
                setMsg(result2.message);
                setOpenmsg(true);
              } else {
                setFaturamento(result2.faturamento);
                setOperacao(result2.descricao);
                setTpag(result2.tpag);
                // Só dá pra decidir a trava (à vista vs. a prazo) depois de saber o tpag
                // desta operação — ver calcularStatuss. Venda cancelada/devolvida força a
                // trava, independente do que calcularStatuss diria — ver vendaBloqueada.
                setStatuss(result.status ? true : calcularStatuss(result.faturado, result.recebidas, result2.tpag));
                setVendaStatus(result.status);
              }
            })
            .finally(() => {
              setIsLoading(false);
              // Setar idparceiro/idoperacao/idplanoconta/iduser acima acabou de disparar a
              // busca interna dos AutoCompletes (cada um resolve seu próprio rótulo/lista de
              // forma independente) — essa folga dá tempo deles terminarem antes do card
              // sumir, evitando que fiquem "carregando" sozinhos logo depois que ele some.
              setTimeout(() => setCarregandoVenda(false), 600);
            });
        });
    } else {
      // Montar uma venda nova não depende de rede (é só resetar o formulário), então sem
      // um atraso mínimo o card de carregamento nem chegaria a aparecer — pisca e some no
      // mesmo frame. Além disso, setar idparceiro/idoperacao/idplanoconta abaixo dispara a
      // busca interna dos AutoCompletes correspondentes, que resolvem sozinhos e levam um
      // tempo — a folga dá chance deles terminarem antes do card sumir.
      setCarregandoVenda(true);

      const accessToken = localStorage.getItem('APP_ACCESS_TOKEN');
      let iduserr = '';
      if (accessToken) {
        const decoded = jwtDecode<JwtPayload>(accessToken);
        iduserr = decoded.iduser || '';
      }
      formRef.current?.setData({
        idparceiro: Environment.URL_IDPARCEIRO,
        idplanoconta: Environment.URL_IDPLANODECONTAS,
        idoperacao: Environment.URL_IDOPERACOES,
        iduser: iduserr,
        emissao: dayjs().tz('America/Sao_Paulo').toDate(),
        numero: '',
        vprod: 0,
        desconto: 0,
        total: 0,
        acrescimo: 0,
        acrescimopercentual: 0,
        descontopercentual: 0,
        obs: '',
      });
      setObsCount(0);
      setRows([]);

      const timeout = setTimeout(() => setCarregandoVenda(false), 600);
      return () => clearTimeout(timeout);
    }
  }, [id]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const tag = (event.target as HTMLElement).tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      if (event.key === 'F3') {
        event.preventDefault();
        if (statuss === false && !isLoading) {
          setIditens('novo');
          setOpenNovo(true);
        }
      }

      if (event.key === 'F4') {
        event.preventDefault();
        setOpenConfirmFinalizar(true);
      }

      if (event.key === 'F10') {
        event.preventDefault();

        if (id === 'novo') {
          setMsg('Salve a venda antes de imprimir');
          setTms('warning');
          setOpenmsg(true);
          return;
        }

        handleImpressao(id);
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        navigate(voltarParaListagem);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [id, statuss, isLoading, voltarParaListagem]);

  const handleSave = (dados: IFormData & {
    descontopercentual?: number;
    acrescimopercentual?: number;
  }) => {
    if (!iniciarSalvamento()) return;
    setMensagemBloqueio(id === 'novo' ? 'Salvando nova venda...' : 'Salvando alterações...');

    const {
      descontopercentual,
      acrescimopercentual,
      ...dadosSemPercentual
    } = dados;

    const dadosAjustados = {
      ...dadosSemPercentual,
      emissao: dayjs(dadosSemPercentual.emissao).format('YYYY-MM-DD'),
    };

    formValidationSchema.validate(dadosAjustados, { abortEarly: false })
      .then(async (dadosValidados) => {
        // Item sem unidade, com preço zerado ou com descrição zerada não pode ir pro backend —
        // normalmente sinal de um produto que ficou sem cadastro vinculado corretamente.
        const itensDaVenda = rows.filter(item => !item.deletado);
        const itemComProblema = itensDaVenda.find(item =>
          !item.un || item.un.trim() === '' ||
          !item.preco || item.preco <= 0 ||
          !item.descricao || item.descricao.trim() === ''
        );
        if (itemComProblema) {
          cancelarSalvamento();
          setTms('error');
          const nomeProduto = itemComProblema.descricao?.trim() || 'sem descrição';
          const problemas: string[] = [];
          if (!itemComProblema.un || itemComProblema.un.trim() === '') problemas.push('está sem unidade (UN)');
          if (!itemComProblema.preco || itemComProblema.preco <= 0) problemas.push('está com o preço zerado');
          if (!itemComProblema.descricao || itemComProblema.descricao.trim() === '') problemas.push('está com a descrição zerada');
          setMsg(`Há um produto na venda que ${problemas.join(' e ')} (${nomeProduto}). Corrija antes de salvar.`);
          setOpenmsg(true);
          return;
        }

        if (tpag === 2 && dadosValidados.idparceiro === Environment.URL_IDPARCEIRO) {
          cancelarSalvamento();
          setTms('error');
          setMsg('Selecione um parceiro para realizar uma venda a prazo!');
          setOpenmsg(true);
          return;
        }

        // Só reconfere estoque no save se a venda estava como Orçamento antes desta edição —
        // é o único jeito de um item sem estoque suficiente ter entrado no carrinho (Orçamento
        // permite, ver permitirSemEstoque). Uma venda que já nasceu/já estava como Venda à
        // Vista/Prazo já teve cada item validado na hora de entrar (permitirSemEstoque=false) ou
        // na troca de operação (handleIdOperacaoChange), então não precisa reconferir a cada save.
        const veioDeOrcamento = dadosOriginais?.idoperacao === Environment.URL_IDORCAMENTO;
        // Venda feita offline (ainda na fila) salva com internet vai ser
        // enviada ao servidor agora (ver VendasService.updateById) — o estoque
        // do servidor ainda não descontou nada dela, e pode ter mudado desde
        // que foi feita, então confere tudo antes de enviar. Faltando estoque,
        // não envia e mostra quais itens (mesmo diálogo de itensSemEstoque).
        const enviandoVendaOffline = !!vendaNaFila && !trabalhandoOffline();
        if (est && (veioDeOrcamento || enviandoVendaOffline) && OPERACOES_DE_VENDA_REAL.includes(dadosValidados.idoperacao)) {
          const itensAtivos = rows.filter(item => !item.deletado);
          if (itensAtivos.length > 0) {
            const resultadoEstoque = await ProdutosService.verificarEstoque(
              itensAtivos.map(item => ({ idprodutos: item.idprodutos, qtde: item.qtds }))
            );
            if (resultadoEstoque instanceof Error) {
              cancelarSalvamento();
              setTms('error');
              setMsg(resultadoEstoque.message);
              setOpenmsg(true);
              return;
            }
            if (resultadoEstoque.length > 0) {
              cancelarSalvamento();
              setItensSemEstoque(resultadoEstoque);
              return;
            }
          }
        }

        let dadosComData: any;

        if (id === 'novo') {
          dadosComData = {
            ...dadosValidados,
            idmov: guuid,
          };
        } else {
          dadosComData = {
            ...dadosValidados,
            idmov: id,
          };
        }

        setCabecalho(dadosComData);

        // Antes de enviar ao backend, arredonda os itens
        // para a precisão configurada (2 ou 4 casas)
        const rowsParaEnvio = rows.filter(item => !item.deletado).map(item => ({
          ...item,
          subtotal: roundDisplay(item.subtotal),
          desconto: roundDisplay(item.desconto),
          voutros: roundDisplay(item.voutros),
          total: roundDisplay(item.total),
        }));
        if (id === 'novo') {
          if (faturamento && tpag === 2) {
            cancelarSalvamento();
            setOpenFaturamento(true);
          } else {
            VendasService
              .create(dadosComData, rowsParaEnvio, [])
              .then(async (result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                  cancelarSalvamento();
                  setTms('error');
                  setMsg(result.message);
                  setOpenmsg(true);
                } else {
                  const salvaOffline = !!(await vendaFrontOffline(result));
                  setTms('success');
                  setMsg(salvaOffline ? 'Venda salva neste computador (sem internet) — será enviada ao servidor quando a conexão voltar.' : 'Venda realizada com sucesso!');
                  setOpenmsg(true);
                  concluirSalvamento();
                  navigate(`/venda/${dadosComData.idmov}`, { state: { from: voltarParaListagem } });
                }
              });
          }
        } else {
          if (faturamento && tpag === 2) {
            cancelarSalvamento();
            setOpenFaturamento(true);
          } else {
            VendasService
              .updateById(id, dadosComData, rowsParaEnvio, rowsids, [])
              .then(async (result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                  cancelarSalvamento();
                  setTms('error');
                  setMsg(result.message);
                  setOpenmsg(true);
                } else {
                  // Venda que estava na fila: diz se chegou ao servidor ou se
                  // continua só neste computador (sem conexão no momento).
                  const aindaNaFila = vendaNaFila ? !!(await buscarVendaNaFila(id).catch(() => undefined)) : false;
                  setTms(aindaNaFila ? 'warning' : 'success');
                  setMsg(!vendaNaFila
                    ? 'Alteração concluída com sucesso!'
                    : aindaNaFila
                      ? 'Alteração salva neste computador — a venda será enviada ao servidor quando a conexão voltar.'
                      : 'Venda enviada ao servidor com sucesso!');
                  setOpenmsg(true);
                  concluirSalvamento();
                  recarregarVenda();
                }
              });
          }
        }
      })
      .catch((errors: yup.ValidationError) => {
        cancelarSalvamento();
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };



  interface IItensidsDevolucao {
  iditens: string;
  iditensOriginal?: string;
  idmov: string;
  idprodutos: string;
  un: string;
  qtde: number;
  qtds: number;
  subtotal: number;
  desconto: number;  // adicionado
  voutros: number;   // adicionado
  total: number;     // adicionado
  tipo: number;
  idref: string;
  preco: number;
  descricao?: string;
}


 interface IDevolucaoItem {
  iditens: string;
  iditensOriginal: string;  // adicionado
  idmov: string;
  idprodutos: string;
  un: string;
  qtde: number;
  qtds: number;
  qtdsOriginal: number;
  subtotal: number;
  tipo: number;
  idref: string;
  preco: number;
  descricao?: string;
}


const handleDevolucaoItem = (item: IDevolucaoItem) => {
  // Busca o item original nas rows pelo iditensOriginal
  const rowOriginal = rows.find(r => r.iditens === item.iditensOriginal);
  if (!rowOriginal) return;

  const qtdOriginal = item.qtdsOriginal;
  const qtdDevolvida = item.qtds;
  const qtdRestante = calcExact(qtdOriginal - qtdDevolvida);

  // ── Proporções baseadas nos valores reais do item, não nos percentuais globais ──
  const propDevolvida = qtdDevolvida / qtdOriginal;
  const propRestante  = qtdRestante  / qtdOriginal;

  // Valores do item devolvido (proporcional à qtd devolvida)
  const subtotalDevolvido = calcExact(qtdDevolvida * rowOriginal.preco);
  const descontoDevolvido = calcExact(rowOriginal.desconto * propDevolvida);
  const voutrosDevolvido  = calcExact(rowOriginal.voutros  * propDevolvida);
  const totalDevolvido    = calcExact(subtotalDevolvido - descontoDevolvido + voutrosDevolvido);

  // Valores do item restante (proporcional à qtd restante)
  const subtotalRestante = calcExact(qtdRestante * rowOriginal.preco);
  const descontoRestante = calcExact(rowOriginal.desconto * propRestante);
  const voutrosRestante  = calcExact(rowOriginal.voutros  * propRestante);
  const totalRestante    = calcExact(subtotalRestante - descontoRestante + voutrosRestante);

  // Se este item original já teve uma devolução parcial antes, reaproveita o
  // mesmo registro e soma a quantidade/valores em vez de criar um novo
  const registroExistente = rowsidsDevolucao.find(d => d.iditensOriginal === item.iditensOriginal);
  const idDevolucao = registroExistente?.iditens ?? item.iditens;

  // 1. Adiciona/acumula o item devolvido no array de devolução
  setRowsidsDevolucao(prev => {
    const jaExiste = prev.findIndex(d => d.iditensOriginal === item.iditensOriginal);

    if (jaExiste >= 0) {
      const atualizado = [...prev];
      const anterior = atualizado[jaExiste];
      atualizado[jaExiste] = {
        ...anterior,
        qtds:     calcExact(anterior.qtds + qtdDevolvida),
        subtotal: roundDisplay(calcExact(anterior.subtotal + subtotalDevolvido)),
        desconto: roundDisplay(calcExact(anterior.desconto + descontoDevolvido)),
        voutros:  roundDisplay(calcExact(anterior.voutros + voutrosDevolvido)),
        total:    roundDisplay(calcExact(anterior.total + totalDevolvido)),
      };
      return atualizado;
    }

    const novoItemDevolucao: IItensidsDevolucao = {
      iditens:    idDevolucao,
      iditensOriginal: item.iditensOriginal,
      idmov:      item.idmov,
      idprodutos: rowOriginal.idprodutos,
      un:         rowOriginal.un,
      qtde:       0,
      qtds:       qtdDevolvida,
      subtotal:   roundDisplay(subtotalDevolvido),
      desconto:   roundDisplay(descontoDevolvido),
      voutros:    roundDisplay(voutrosDevolvido),
      total:      roundDisplay(totalDevolvido),
      tipo:       2,
      idref:      rowOriginal.idref,
      preco:      rowOriginal.preco,
      descricao:  rowOriginal.descricao,
    };
    return [...prev, novoItemDevolucao];
  });

  // 2. Atualiza o item original com a quantidade/valores restantes e
  //    acumula a linha vermelha (deletado) já existente para esse item,
  //    ou cria uma nova caso seja a primeira devolução parcial dele
  setRows(prevRows => {
    const existeLinhaDevolvida = prevRows.some(
      row => row.deletado && row.iditensOriginal === item.iditensOriginal
    );

    const novasRows = prevRows.map(row => {
      if (row.iditens === item.iditensOriginal) {
        // Devolução total: o item original também fica marcado como deletado
        if (qtdRestante <= 0) {
          return { ...row, deletado: true };
        }

        return {
          ...row,
          qtds:     qtdRestante,
          subtotal: subtotalRestante,
          desconto: descontoRestante,
          voutros:  voutrosRestante,
          total:    totalRestante,
        };
      }

      if (existeLinhaDevolvida && row.deletado && row.iditensOriginal === item.iditensOriginal) {
        return {
          ...row,
          qtds:     calcExact(row.qtds + qtdDevolvida),
          subtotal: calcExact(row.subtotal + subtotalDevolvido),
          desconto: calcExact(row.desconto + descontoDevolvido),
          voutros:  calcExact(row.voutros + voutrosDevolvido),
          total:    calcExact(row.total + totalDevolvido),
        };
      }

      return row;
    });

    const linhaDevolvida: IitensEntradaDialog = {
      ...rowOriginal,
      iditens:  idDevolucao,
      iditensOriginal: item.iditensOriginal,
      qtds:     qtdDevolvida,
      subtotal: subtotalDevolvido,
      desconto: descontoDevolvido,
      voutros:  voutrosDevolvido,
      total:    totalDevolvido,
      deletado: true,
    };

    const todasRows = existeLinhaDevolvida
      ? novasRows
      : (qtdRestante <= 0 ? novasRows : [...novasRows, linhaDevolvida]);

    // 3. Recalcula os totais do cabeçalho somente com itens ativos
    const itensAtivos = todasRows.filter(r => !r.deletado);
    const vprodNovo         = calcExact(itensAtivos.reduce((acc, r) => acc + r.subtotal, 0));
    const descontoTotalNovo = calcExact(itensAtivos.reduce((acc, r) => acc + r.desconto, 0));
    const acrescimoTotalNovo= calcExact(itensAtivos.reduce((acc, r) => acc + r.voutros,  0));
    const totalGeralNovo    = calcExact(vprodNovo - descontoTotalNovo + acrescimoTotalNovo);

    formRef.current?.setFieldValue('vprod',    roundDisplay(vprodNovo));
    formRef.current?.setFieldValue('desconto', roundDisplay(descontoTotalNovo));
    formRef.current?.setFieldValue('acrescimo',roundDisplay(acrescimoTotalNovo));
    formRef.current?.setFieldValue('total',    roundDisplay(totalGeralNovo));

    return todasRows;
  });
};

  const recarregarVenda = () => {
    setRows([]);
    setRowsids([]);
    setRowsidsDevolucao([]);
    setModoDevolucaoAtivo(false);
    setIsLoading(true);
    setCarregandoVenda(true);
    VendasService.getById(id).then((result) => {
      if (result instanceof Error) {
        setIsLoading(false);
        setCarregandoVenda(false);
        setTms('error');
        setMsg(result.message);
        setOpenmsg(true);
        return;
      }

      setDadosOriginais(result);
      formRef.current?.setData(result);
      setIdOperacaoAtual(result.idoperacao);
      setObsCount(((result as any).obs || '').length);
      setRows(
        result.itens.map((item: IitensEntradaDialog) => ({
          ...item,
          status: 1,
        }))
      );
      const vprod = result.vprod || 0;
      const desconto = result.desconto || 0;
      const acrescimo = result.acrescimo || 0;
      if (vprod > 0) {
        formRef.current?.setFieldValue('descontopercentual', Number(((desconto / vprod) * 100).toFixed(4)));
        formRef.current?.setFieldValue('acrescimopercentual', Number(((acrescimo / vprod) * 100).toFixed(4)));
      }
      // A operação (e o tpag) não muda num reload — reaproveita o `tpag` já carregado (ver
      // calcularStatuss). Venda cancelada/devolvida força a trava — ver vendaBloqueada.
      setStatuss(result.status ? true : calcularStatuss(result.faturado, result.recebidas, tpag));
      setVendaStatus(result.status);

      setIsLoading(false);
      // Mesma folga do efeito de carregamento inicial: idparceiro/idoperacao acabaram de
      // mudar e disparam a busca interna dos AutoCompletes, que resolvem de forma
      // independente e levam um tempo.
      setTimeout(() => setCarregandoVenda(false), 600);
    });
  };

  const handlePrepararDevolucao = () => {
    const data = formRef.current?.getData();

    setCabecalho(prev =>
      prev
        ? {
          ...prev,
          vprod: Number(data?.vprod || 0),
          desconto: Number(data?.desconto || 0),
          acrescimo: Number(data?.acrescimo || 0),
          total: Number(data?.total || 0),
        }
        : prev
    );

    setModoDevolucaoAtivo(true);
    setOpenConfirmDevolucao(true);
  };

  const handleConfirmDevolucao = () => {
    setOpenConfirmDevolucao(false);
    setModoDevolucaoAtivo(false);

    if (!dadosOriginais) {
      setTms('error');
      setMsg('Dados da venda não encontrados!');
      setOpenmsg(true);
      return;
    }
    const data = formRef.current?.getData();

    const dadosParaDevolucao = {
      idmov: id,
      idparceiro: dadosOriginais.idparceiro,
      iduser: dadosOriginais.iduser,
      idplanoconta: dadosOriginais.idplanoconta,
      idoperacao: dadosOriginais.idoperacao,
      numero: dadosOriginais.numero,
      emissao: dadosOriginais.emissao,

      vprod: Number(data?.vprod || 0),
      desconto: Number(data?.desconto || 0),
      acrescimo: Number(data?.acrescimo || 0),
      total: Number(data?.total || 0),
      obs: dadosOriginais.obs +' Teve Devolução',
    };

    handleSaveDevolucao(dadosParaDevolucao, rowsidsDevolucao);
  };


  const handleSaveDevolucao = (dados: IFormData, itens: IItensidsDevolucao[]) => {
    if (!iniciarSalvamento()) return;
    setMensagemBloqueio('Processando devolução...');

    const {
      ...dadosSemPercentual
    } = dados;

    const dadosAjustados = {
      ...dadosSemPercentual,
      emissao: dayjs(dadosSemPercentual.emissao).format('YYYY-MM-DD'),
    };
    formValidationSchema.validate(dadosAjustados, { abortEarly: false })
      .then((dadosValidados) => {
        const dadosComData = {
          ...dadosValidados,
          idmov: id,
        };
        setCabecalho(dadosComData);
        setIsLoading(true);

        const rowsAtivas = rows.filter(item => !item.deletado);

        VendasService.updateByIdDevolucao(id, dadosComData, rowsAtivas, itens, [])
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              cancelarSalvamento();
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTms('success');
              setMsg('Devolução realizada com sucesso!');
              setOpenmsg(true);
              concluirSalvamento();
              recarregarVenda();
            }
          })
          .catch((error) => {
            setIsLoading(false);
            cancelarSalvamento();
            setTms('error');
            setMsg('Erro ao processar devolução: ' + (error.message || 'Erro desconhecido'));
            setOpenmsg(true);
          });

      })
      .catch((errors: yup.ValidationError) => {
        cancelarSalvamento();
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };


  useEffect(() => {
    const LARGURA_IDEAL = 980;
    const FATOR_LARGURA_MINIMO = 0.78;

    const ajustarDensidadeTabela = () => {
      if (!tabelaItensRef.current) return;

      const largura = tabelaItensRef.current.clientWidth;
      const fatorLargura = Math.min(
        Math.max(largura / LARGURA_IDEAL, FATOR_LARGURA_MINIMO),
        1
      );

      setDensidadeTabela({
        rowPy: Number((0.5 * fatorLargura).toFixed(2)),
        rowFontSize: Number((0.95 * Math.max(fatorLargura, 0.85)).toFixed(2)),
        headerPy: Number((0.5 * fatorLargura).toFixed(2)),
        headerFontSize: Number((0.75 * Math.max(fatorLargura, 0.85)).toFixed(2)),
        cellPx: Number((1 * fatorLargura).toFixed(2)),
        descricaoMaxWidth: Math.round(220 * fatorLargura),
        refMaxWidth: Math.round(120 * fatorLargura),
      });
    };

    ajustarDensidadeTabela();

    const resizeObserver = new ResizeObserver(ajustarDensidadeTabela);
    if (tabelaItensRef.current) {
      resizeObserver.observe(tabelaItensRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    return () => {
      if (pdfBlobUrl) {
        URL.revokeObjectURL(pdfBlobUrl);
      }
    };
  }, [pdfBlobUrl]);
  const handleBuscarDados = (id: string) => {
    const foundItem = rows.find((listItem) => listItem.iditens === id);
    if (foundItem) {
      setDadositens(foundItem);
    }
  };
  const handleCloseFaturamento = (newValue?: string) => {
    setOpenFaturamento(false);
    setIsLoading(false);
    if (newValue !== undefined) {
      if (newValue === id) {
        recarregarVenda();
      } else {
        navigate(`/venda/${newValue}`, { state: { from: voltarParaListagem } });
      }
    }
  };






  const handleImpressao = async (id: string) => {
    const authAtual = getAuth();
    const tipo = authAtual?.tipoimp ?? 1;

    // Abre a dialog já no início (não só quando o PDF fica pronto) — é isso que faz o
    // card "Carregando impressão..." aparecer enquanto o PDF é gerado, em vez de só ser
    // montado depois que tudo já terminou.
    setIsGeneratingPdf(true);
    setOpenPdfViewer(true);
    try {
      const result = await VendasService.Impressao(id);
      if (result instanceof Error) {
        setOpenPdfViewer(false);
        setTms('error');
        setMsg(result.message);
        setOpenmsg(true);
      } else {
        let pdfBlob: Blob;
        if (dadosOriginais?.idoperacao === Environment.URL_IDORCAMENTO) {
          pdfBlob = await PDFORCAMENTO(result);
        } else if (tipo === 2) {
          pdfBlob = await PDFVenda02(result);
        } else {
          pdfBlob = await PDFVenda01(result);
        }
        if (pdfBlobUrl) {
          URL.revokeObjectURL(pdfBlobUrl);
        }
        const blobUrl = URL.createObjectURL(pdfBlob);
        setPdfBlobUrl(blobUrl);
      }
    } catch (error) {
      setOpenPdfViewer(false);
      setTms('error');
      setMsg('Erro ao gerar o PDF');
      setOpenmsg(true);
    } finally {
      setIsGeneratingPdf(false);
    }
  };

  // Carnê de pagamento: 1 card por parcela (contasreceber) dessa venda — à
  // vista sai com 1 card só (a venda gera 1 parcela também), a prazo com N.
  // Reaproveita o mesmo visualizador de PDF do botão "Imprimir" normal.
  const handleImprimirCarne = async (idmov: string) => {
    setIsGeneratingCarne(true);
    setOpenPdfViewer(true);
    try {
      const [parcelas, impressao] = await Promise.all([
        ContasReceberService.getPorVenda(idmov),
        // Só pra pegar nome/fantasia/logo da EMPRESA (não existe em
        // getPorVenda) — mesma fonte já usada no PDF normal de venda
        // (impressaovenda01.ts), pra não inventar outro jeito de buscar isso.
        VendasService.Impressao(idmov),
      ]);
      if (parcelas instanceof Error) {
        setOpenPdfViewer(false);
        setTms('error');
        setMsg(parcelas.message);
        setOpenmsg(true);
        return;
      }
      const empresa = !(impressao instanceof Error) ? impressao.empresa?.[0] : undefined;

      let dadosCarne: IDadosCarne;

      if (parcelas.length > 0) {
        dadosCarne = {
          cliente: parcelas[0].cliente,
          cpf: parcelas[0].cpf,
          numeroVenda: parcelas[0].numero,
          logo: empresa?.logo || parcelas[0].logo || undefined,
          empresaFantasia: empresa?.fantasia,
          empresaRazaoSocial: empresa?.nome,
          parcelas: parcelas.map((p) => ({
            numero: p.numero,
            parcela: p.parcela,
            vencimento: p.vencimento,
            valor: p.vparcela,
            status: p.status,
            datapagamento: p.datapagamento,
            formapagamento: p.formapagamento,
          })),
        };
      } else {
        // Venda à vista sem nenhuma linha em contasreceber (recebida direto
        // no caixa, sem gerar contas a receber) — em vez do aviso "nenhuma
        // parcela encontrada" (que bloqueava a impressão), monta um canhoto
        // único com o valor total da venda, sem falar em parcela/vencimento.
        const venda = await VendasService.getById(idmov);
        if (venda instanceof Error) {
          setOpenPdfViewer(false);
          setTms('error');
          setMsg(venda.message);
          setOpenmsg(true);
          return;
        }
        let cpfParceiro: string | undefined;
        const parceiro = await ParceirosService.getById(venda.idparceiro);
        if (!(parceiro instanceof Error)) cpfParceiro = parceiro.cpf;

        dadosCarne = {
          cliente: venda.nome,
          cpf: cpfParceiro,
          numeroVenda: venda.numero,
          logo: empresa?.logo,
          empresaFantasia: empresa?.fantasia,
          empresaRazaoSocial: empresa?.nome,
          parcelas: [{
            numero: venda.numero,
            parcela: 'ÚNICA',
            vencimento: venda.emissao,
            valor: venda.total,
            status: true,
            datapagamento: venda.emissao,
            formapagamento: 'À vista',
          }],
        };
      }

      const pdfBlob = await gerarCarne(dadosCarne);
      if (pdfBlobUrl) {
        URL.revokeObjectURL(pdfBlobUrl);
      }
      const blobUrl = URL.createObjectURL(pdfBlob);
      setPdfBlobUrl(blobUrl);
    } catch (error) {
      setOpenPdfViewer(false);
      setTms('error');
      setMsg('Erro ao gerar o carnê');
      setOpenmsg(true);
    } finally {
      setIsGeneratingCarne(false);
    }
  };

  const handleClosePdfViewer = () => {
    if (pdfBlobUrl) {
      URL.revokeObjectURL(pdfBlobUrl);
      setPdfBlobUrl(null);
    }
    setOpenPdfViewer(false);
  };
  const handleDownloadPdf = () => {
    if (pdfBlobUrl) {
      const link = document.createElement('a');
      link.href = pdfBlobUrl;
      link.download = `venda_${id}.pdf`;
      link.click();
    }
  };
  const handlePrintPdf = () => {
    if (pdfBlobUrl) {
      const printWindow = window.open(pdfBlobUrl, '_blank');
      printWindow?.print();
    }
  };
  const handlecpf = (cpfs: string | undefined) => {
    if (cpfs != null && cpfs !== '') {
      formRef.current?.setFieldValue('cpf', cpfs);
    } else {
      formRef.current?.setFieldValue('cpf', '');
    }
  };

  const handleParceiroBloqueado = () => {
    setTms('error');
    setMsg('Cliente bloqueado. Consulte o cadastro de parceiros ou o setor responsável.');
    setOpenmsg(true);
  };






  // Chamado a cada item adicionado na DialogVenda — o item já vem pronto (novo ou com a
  // quantidade já somada, se o produto já estava na venda) e deve ser salvo na listagem
  // imediatamente, não só quando a dialog fechar (ela nem fecha mais sozinha ao adicionar).
  // Upsert por iditens: mesmo id já existente em rows → substitui (quantidade atualizada);
  // id novo → acrescenta.
  const handleAdicionarItemNaVenda = (item: IitensEntradaDialog) => {
    setRows(prevRows => {
      const jaExiste = prevRows.some(row => row.iditens === item.iditens);
      const novosItens = jaExiste
        ? prevRows.map(row => (row.iditens === item.iditens ? item : row))
        : [...prevRows, item];

      return recalcularTotais(novosItens);
    });
  };
  const CALC_PRECISION = 8;

  const calcExact = (value: number) =>
    Number(value.toFixed(CALC_PRECISION));

  const roundDisplay = (value: number) =>
    Number(value.toFixed(decimais));

  const recalcularTotais = (
    itens: IitensEntradaDialog[],
    percentualDesconto?: number,
    percentualAcrescimo?: number,
    atualizarCabecalho = true
  ) => {
    const data = formRef.current?.getData();

    // Percentuais usados nos cálculos internos
    const percDesc =
      percentualDesconto ??
      Number(data?.descontopercentual || 0);

    const percAcres =
      percentualAcrescimo ??
      Number(data?.acrescimopercentual || 0);

    // Cálculos internos com alta precisão (8 casas)
    // Itens marcados como deletado ficam congelados (não entram no recálculo)
    const novosItens = itens.map(item => {
      if (item.deletado) return item;

      const subtotal = calcExact(
        Number(item.qtds) * Number(item.preco)
      );

      const desconto = calcExact(
        (subtotal * percDesc) / 100
      );

      const voutros = calcExact(
        (subtotal * percAcres) / 100
      );

      const total = calcExact(
        subtotal - desconto + voutros
      );

      return {
        ...item,
        subtotal,
        desconto,
        voutros,
        total,
      };
    });

    const itensAtivos = novosItens.filter(item => !item.deletado);

    // Totalizações com alta precisão (somente itens ativos)
    const vprod = calcExact(
      itensAtivos.reduce((acc, item) => acc + item.subtotal, 0)
    );

    const descontoTotal = calcExact(
      itensAtivos.reduce((acc, item) => acc + item.desconto, 0)
    );

    const acrescimoTotal = calcExact(
      itensAtivos.reduce((acc, item) => acc + item.voutros, 0)
    );

    const totalGeral = calcExact(
      vprod - descontoTotal + acrescimoTotal
    );

    // Somente aqui arredonda para exibição no formulário
    formRef.current?.setFieldValue('vprod', roundDisplay(vprod));

    if (atualizarCabecalho) {
      formRef.current?.setFieldValue('desconto', roundDisplay(descontoTotal));
      formRef.current?.setFieldValue('acrescimo', roundDisplay(acrescimoTotal));
    }

    formRef.current?.setFieldValue('total', roundDisplay(totalGeral));

    // Os itens ficam no estado com 8 casas decimais para cálculos futuros
    return novosItens;
  };









  const handleDesconto = (valor: number | undefined) => {
    if (valor === undefined || isNaN(valor)) return;

    const data = formRef.current?.getData();
    const vprod = Number(data?.vprod) || 0;

    if (vprod <= 0) return;

    // Percentual calculado com alta precisão
    const percentual = calcExact((valor / vprod) * 100);

    // Exibe no formulário com precisão configurada
    formRef.current?.setFieldValue('desconto', roundDisplay(valor));
    formRef.current?.setFieldValue(
      'descontopercentual',
      Number(percentual.toFixed(4))
    );

    // Distribuição do desconto somente entre os itens ativos (não deletados)
    let descontoDistribuido = 0;
    const itensAtivos = rows.filter(item => !item.deletado);

    const itensAtivosAtualizados = itensAtivos.map((item, index) => {
      const subtotal = calcExact(
        Number(item.qtds) * Number(item.preco)
      );

      let descontoItem = calcExact(
        (subtotal * percentual) / 100
      );

      // Último item ativo absorve a diferença de arredondamento
      // garantindo que a soma dos descontos seja exata
      if (index === itensAtivos.length - 1) {
        descontoItem = calcExact(valor - descontoDistribuido);
      } else {
        descontoDistribuido = calcExact(
          descontoDistribuido + descontoItem
        );
      }

      const voutros = calcExact(
        (subtotal * Number(data?.acrescimopercentual || 0)) / 100
      );

      const total = calcExact(
        subtotal - descontoItem + voutros
      );

      return {
        ...item,
        subtotal,
        desconto: descontoItem,
        voutros,
        total,
      };
    });

    let i = 0;
    const itensAtualizados = rows.map(item =>
      item.deletado ? item : itensAtivosAtualizados[i++]
    );

    const descontoTotal = calcExact(
      itensAtivosAtualizados.reduce((acc, item) => acc + item.desconto, 0)
    );

    const acrescimoTotal = calcExact(
      itensAtivosAtualizados.reduce((acc, item) => acc + item.voutros, 0)
    );

    const totalGeral = calcExact(
      vprod - descontoTotal + acrescimoTotal
    );

    // Apenas o total exibido é arredondado para o usuário
    formRef.current?.setFieldValue('total', roundDisplay(totalGeral));

    setRows(itensAtualizados);
  };



  const handleAcrescimo = (valor: number | undefined) => {
    if (valor === undefined || isNaN(valor)) return;

    const data = formRef.current?.getData();
    const vprod = Number(data?.vprod) || 0;

    if (vprod <= 0) return;

    // Percentual calculado com alta precisão
    const percentual = calcExact((valor / vprod) * 100);

    // Exibe no formulário com precisão configurada
    formRef.current?.setFieldValue('acrescimo', roundDisplay(valor));
    formRef.current?.setFieldValue(
      'acrescimopercentual',
      Number(percentual.toFixed(4))
    );

    // Distribuição do acréscimo somente entre os itens ativos (não deletados)
    let acrescimoDistribuido = 0;
    const itensAtivos = rows.filter(item => !item.deletado);

    const itensAtivosAtualizados = itensAtivos.map((item, index) => {
      const subtotal = calcExact(
        Number(item.qtds) * Number(item.preco)
      );

      let acrescimoItem = calcExact(
        (subtotal * percentual) / 100
      );

      // Último item ativo absorve a diferença de arredondamento
      // garantindo que a soma dos acréscimos seja exata
      if (index === itensAtivos.length - 1) {
        acrescimoItem = calcExact(valor - acrescimoDistribuido);
      } else {
        acrescimoDistribuido = calcExact(
          acrescimoDistribuido + acrescimoItem
        );
      }

      const desconto = calcExact(
        (subtotal * Number(data?.descontopercentual || 0)) / 100
      );

      const total = calcExact(
        subtotal - desconto + acrescimoItem
      );

      return {
        ...item,
        subtotal,
        desconto,
        voutros: acrescimoItem,
        total,
      };
    });

    let i = 0;
    const itensAtualizados = rows.map(item =>
      item.deletado ? item : itensAtivosAtualizados[i++]
    );

    const descontoTotal = calcExact(
      itensAtivosAtualizados.reduce((acc, item) => acc + item.desconto, 0)
    );

    const acrescimoTotal = calcExact(
      itensAtivosAtualizados.reduce((acc, item) => acc + item.voutros, 0)
    );

    const totalGeral = calcExact(
      vprod - descontoTotal + acrescimoTotal
    );

    // Apenas o total exibido é arredondado para o usuário
    formRef.current?.setFieldValue('total', roundDisplay(totalGeral));

    setRows(itensAtualizados);
  };







  const handlePercentualDesconto = (percentual: number) => {
    const percentNum = calcExact(Number(percentual) || 0);

    formRef.current?.setFieldValue(
      'descontopercentual',
      Number(percentNum.toFixed(4))
    );

    // recalcularTotais já usa calcExact internamente
    const itensAtualizados = recalcularTotais(rows, percentNum);

    setRows(itensAtualizados);
  };


  const handlePercentualAcrescimo = (percentual: number) => {
    const percentNum = calcExact(Number(percentual) || 0);

    formRef.current?.setFieldValue(
      'acrescimopercentual',
      Number(percentNum.toFixed(4))
    );

    // recalcularTotais já usa calcExact internamente
    const itensAtualizados = recalcularTotais(
      rows,
      undefined,
      percentNum
    );

    setRows(itensAtualizados);
  };

  const handleFaturamento = (faturamento: boolean | undefined) => {
    setFaturamento(faturamento);
  };

  const handleTpag = (tpag: number | undefined) => {
    setTpag(tpag);
  };
  const handleVenda = (venda: boolean | undefined) => {
    setvenda(venda);
  };
  const handleOperacao = (operacao: string | undefined) => {
    setOperacao(operacao);
  };
  // Orçamento não move estoque de verdade (ver permitirSemEstoque nos DialogVenda abaixo) — só
  // nele dá pra lançar item sem estoque disponível. Ao tentar trocar pra uma operação que move
  // estoque de verdade (Venda à Vista/Prazo), confere ANTES de aplicar a troca: só chama
  // setIdOperacaoAtual (o que de fato libera permitirSemEstoque=false e reflete no formulário)
  // se todos os itens já lançados tiverem estoque suficiente. Se não tiverem — ou se a própria
  // checagem falhar — a troca é recusada: o campo volta pro valor anterior
  // (formRef.setFieldValue, que a AutoCompleteOperacoes escuta via unform) e o dialog de aviso
  // (itensSemEstoque) explica o motivo. Não dá mais pra sair de Orçamento com o carrinho nesse
  // estado. handleSave ainda repete essa mesma checagem na hora de salvar, como rede de
  // segurança final (cobre venda que já nasceu como Venda à Vista/Prazo, e estoque que mudou
  // depois dessa troca).
  const handleIdOperacaoChange = (novoId: string | undefined) => {
    // Só reconfere/mapeia estoque quando a troca É de Orçamento pra uma operação real —
    // trocar entre operações que já movem estoque de verdade (Venda à Vista <-> Prazo) não
    // repete essa checagem: nesses casos o carrinho nunca teve item sem estoque suficiente
    // (permitirSemEstoque=false o tempo todo), então não há nada novo pra mapear.
    const saindoDeOrcamento = idOperacaoAtual === Environment.URL_IDORCAMENTO;
    if (est && novoId && saindoDeOrcamento && OPERACOES_DE_VENDA_REAL.includes(novoId)) {
      const itensAtivos = rows.filter(item => !item.deletado);
      if (itensAtivos.length > 0) {
        const operacaoAnterior = idOperacaoAtual;
        setVerificandoEstoque(true);
        ProdutosService
          .verificarEstoque(itensAtivos.map(item => ({ idprodutos: item.idprodutos, qtde: item.qtds })))
          .then((resultado) => {
            setVerificandoEstoque(false);
            if (resultado instanceof Error) {
              setTms('error');
              setMsg(resultado.message);
              setOpenmsg(true);
              formRef.current?.setFieldValue('idoperacao', operacaoAnterior);
              return;
            }
            if (resultado.length > 0) {
              setItensSemEstoque(resultado);
              formRef.current?.setFieldValue('idoperacao', operacaoAnterior);
              return;
            }
            setIdOperacaoAtual(novoId);
          });
        return;
      }
    }

    setIdOperacaoAtual(novoId);
  };
  const handleConfirmFinalizar = () => {
    setOpenConfirmFinalizar(false);
    formRef.current?.submitForm();
  };
  const handleCancelFinalizar = () => {
    setOpenConfirmFinalizar(false);
  };

  const itensAtivosCount = rows.filter(item => !item.deletado).length;

  const podeAlterarDescontoAcrescimo =
    statuss === true &&
    tpag === 1 &&
    faturamento === true &&
    !vendaBloqueada &&
    rowsidsDevolucao.length > 0 &&
    itensAtivosCount > 0;

  // Editar um item (lápis da tabela/cartão): numa venda já faturada e
  // recebida, abre direto no modo devolução. Venda cancelada/devolvida
  // (vendaBloqueada) não abre nada — só visualização.
  const abrirEdicaoItem = (iditensSelecionado: string) => {
    if (vendaBloqueada) return;
    const devolucaoHabilitada = faturamento === true && statuss === true;

    if (devolucaoHabilitada) {
      setModoDevolucaoAtivo(true);

      setMsg('🔁 Modo devolução ativado! Informe a quantidade a ser devolvida.');
      setTms('info');
      setOpenmsg(true);
    } else {
      setModoDevolucaoAtivo(false);
    }

    setIditens(iditensSelecionado);
    handleBuscarDados(iditensSelecionado);
    setOpenEdit(true);
  };

  const formatarQtd = (valor: number) => valor.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 4 });
  const formatarValor = (valor: number) => (valor ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 4 });
  const podeAdicionarItem = statuss === false && !isLoading;

  // Celular: itens em cartões (a tabela tem colunas demais pra ~390px) —
  // descrição, "qtd × preço", desconto/outros quando houver e o total; lápis
  // e lixeira à direita. Sem altura fixa: a lista cresce com os itens.
  const itensCartoes = (
    <Box>
      <Button
        fullWidth
        variant="contained"
        startIcon={<AddShoppingCartIcon />}
        disabled={!podeAdicionarItem}
        onClick={() => {
          setIditens('novo');
          setOpenNovo(true);
        }}
        sx={{ mb: 1.25, height: 46, borderRadius: '12px', fontWeight: 700, textTransform: 'none' }}
      >
        Adicionar item
      </Button>
      {rows.length === 0 ? (
        <Box sx={{ py: 5, textAlign: 'center', color: 'text.secondary', border: '1px dashed', borderColor: 'divider', borderRadius: 2 }}>
          <AddShoppingCartIcon sx={{ fontSize: 34, opacity: 0.5, mb: 0.5 }} />
          <Typography variant="body2">Nenhum item adicionado</Typography>
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" gap={1}>
          {[...rows]
            .sort((a, b) => (a.deletado === b.deletado ? 0 : a.deletado ? -1 : 1))
            .map((row) => (
              <Box
                key={row.iditens}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  p: 1.25,
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: row.deletado ? 'error.light' : 'divider',
                  bgcolor: (t) => row.deletado ? alpha(t.palette.error.main, 0.08) : t.palette.background.paper,
                }}
              >
                <Box flex={1} minWidth={0} onClick={() => !row.deletado && abrirEdicaoItem(row.iditens)} sx={{ cursor: row.deletado ? 'default' : 'pointer' }}>
                  <Typography
                    variant="body2"
                    fontWeight={700}
                    color={row.deletado ? 'error.main' : 'text.primary'}
                    sx={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: 1.3, textDecoration: row.deletado ? 'line-through' : 'none' }}
                  >
                    {row.descricao}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" component="div" noWrap>
                    {formatarQtd(row.qtds)} {row.un} × {formatarValor(row.preco)}
                    {row.referencia ? ` · Ref ${row.referencia}` : ''}
                  </Typography>
                  {(Number(row.desconto) > 0 || Number(row.voutros) > 0) && (
                    <Typography variant="caption" color="text.secondary" component="div" noWrap>
                      {Number(row.desconto) > 0 ? `Desc. ${formatarValor(row.desconto)}` : ''}
                      {Number(row.desconto) > 0 && Number(row.voutros) > 0 ? ' · ' : ''}
                      {Number(row.voutros) > 0 ? `Outros ${formatarValor(row.voutros)}` : ''}
                    </Typography>
                  )}
                  {row.deletado && (
                    <Typography variant="caption" color="error.main" fontWeight={700} component="div">Removido</Typography>
                  )}
                </Box>
                <Typography variant="body2" fontWeight={800} color={row.deletado ? 'error.main' : 'success.main'} sx={{ whiteSpace: 'nowrap' }}>
                  {formatarValor(row.total ?? 0)}
                </Typography>
                <Box display="flex" flexDirection="column" sx={{ ml: -0.25 }}>
                  <IconButton size="small" color="primary" disabled={row.deletado || vendaBloqueada} onClick={() => abrirEdicaoItem(row.iditens)} aria-label="Editar item">
                    <Icon fontSize="small">edit</Icon>
                  </IconButton>
                  <IconButton size="small" disabled={row.deletado || vendaBloqueada} onClick={() => handleDeleteItem(row.iditens)} aria-label="Remover item" sx={{ color: 'text.secondary' }}>
                    <Icon fontSize="small">delete</Icon>
                  </IconButton>
                </Box>
              </Box>
            ))}
        </Box>
      )}
    </Box>
  );

  // Data, número e valores do pedido (totais, descontos, acréscimos). No
  // computador ficam junto do cabeçalho; no celular, num bloco próprio depois
  // dos itens — é o "resumo" da venda, como num app.
  const camposValores = (
                <Grid container spacing={1.5} sx={{ mt: smDown ? 0 : 1.5 }}>
                  <Grid item xs={6} sm={4} md>
                    <VTextFieldData
                      fullWidth
                      size='small'
                      name='emissao'
                      label='Data de Emissão'
                      disabled={statuss === false ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={4} md>
                    <VTextField
                      fullWidth
                      size='small'
                      name='numero'
                      label='Numero'
                      InputProps={{
                        disabled: true,
                      }}
                      sx={numeroCampoSx}
                    />
                  </Grid>
                  {decimais === 4 ? (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoney4
                        fullWidth
                        size='small'
                        name='vprod'
                        label='Total produtos'
                        disabled={true}
                        sx={destaqueCampoSx}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='vprod'
                        label='Total produtos'
                        sx={destaqueCampoSx}
                        disabled={true}
                      />
                    </Grid>
                  )}
                  {decimais === 4 ? (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='desconto'
                        label='Desconto (R$)'
                        disabled={statuss === false ? isLoading : (podeAlterarDescontoAcrescimo ? isLoading : true)}
                        calcular={handleDesconto}
                        sx={destaqueCampoSx}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='desconto'
                        label='Desconto (R$)'
                        disabled={statuss === false ? isLoading : (podeAlterarDescontoAcrescimo ? isLoading : true)}
                        calcular={handleDesconto}
                        sx={destaqueCampoSx}
                      />
                    </Grid>
                  )}
                  {decimais === 4 ? (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='descontopercentual'
                        label='Desconto (%)'
                        calcular={(valor) => handlePercentualDesconto(valor)}
                        disabled={statuss === false ? isLoading : (podeAlterarDescontoAcrescimo ? isLoading : true)}
                        InputProps={{
                          endAdornment: '%',
                        }}
                        sx={destaqueCampoSx}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='descontopercentual'
                        label='Desconto (%)'
                        calcular={(valor) => handlePercentualDesconto(valor)}
                        disabled={statuss === false ? isLoading : (podeAlterarDescontoAcrescimo ? isLoading : true)}
                        InputProps={{
                          endAdornment: '%',
                        }}
                        sx={destaqueCampoSx}
                      />
                    </Grid>
                  )}
                  {decimais === 4 ? (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='acrescimo'
                        label='Acréscimo (R$)'
                        disabled={statuss === false ? isLoading : (podeAlterarDescontoAcrescimo ? isLoading : true)}
                        calcular={handleAcrescimo}
                        sx={destaqueCampoSx}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='acrescimo'
                        label='Acréscimo (R$)'
                        disabled={statuss === false ? isLoading : (podeAlterarDescontoAcrescimo ? isLoading : true)}
                        calcular={handleAcrescimo}
                        sx={destaqueCampoSx}
                      />
                    </Grid>
                  )}
                  {decimais === 4 ? (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='acrescimopercentual'
                        label='Acrescimo (%)'
                        calcular={(valor) => handlePercentualAcrescimo(valor)}
                        disabled={statuss === false ? isLoading : (podeAlterarDescontoAcrescimo ? isLoading : true)}
                        InputProps={{
                          endAdornment: '%',
                        }}
                        sx={destaqueCampoSx}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='acrescimopercentual'
                        label='Acrescimo (%)'
                        calcular={(valor) => handlePercentualAcrescimo(valor)}
                        disabled={statuss === false ? isLoading : (podeAlterarDescontoAcrescimo ? isLoading : true)}
                        InputProps={{
                          endAdornment: '%',
                        }}
                        sx={destaqueCampoSx}
                      />
                    </Grid>
                  )}
                  {decimais === 4 ? (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='total'
                        label='Total do Pedido'
                        disabled={true}
                        sx={totalCampoSx}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={6} sm={4} md>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='total'
                        label='Total do Pedido'
                        disabled
                        sx={totalCampoSx}
                      />
                    </Grid>
                  )}
                </Grid>
  );

  // Vendedor e observações — no computador embaixo da tabela de itens; no
  // celular num bloco próprio, por último (depois dos valores).
  const camposVendedorObs = (
                <Grid container item direction="row" spacing={1.5} sx={{ mt: smDown ? 0 : 0.5 }}>
                  <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                    <AutoCompleteVendedor
                      isExternalLoading={statuss === false ? isLoading : true}
                      disabled={id !== 'novo'}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                    <Box sx={{ position: 'relative' }}>
                      <VTextField
                        fullWidth
                        size='small'
                        name='obs'
                        disabled={statuss === false ? isLoading : true}
                        label='Observações'
                        placeholder='Digite observações sobre a venda...'
                        multiline
                        minRows={1}
                        maxRows={6}
                        valor={(novoValor) => setObsCount((novoValor || '').length)}
                        inputProps={{ maxLength: LIMITE_OBS }}
                      />
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ position: 'absolute', right: 12, bottom: 8, pointerEvents: 'none' }}
                      >
                        {obsCount} / {LIMITE_OBS}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
  );

  const itensTable = (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        width: '100%',
        minHeight: ALTURA_TABELA_ITENS,
        maxHeight: ALTURA_TABELA_ITENS,
        overflowY: 'auto',
        overflowX: 'auto',
        backgroundColor: theme =>
          theme.palette.mode === 'light'
            ? alpha(theme.palette.grey[200], 0.55)
            : theme.palette.background.default,

        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        p: 0,
        scrollbarWidth: 'thin',
        scrollbarColor: theme =>
          theme.palette.mode === 'dark'
            ? `${alpha(theme.palette.grey[400], 0.4)} transparent`
            : `${alpha(theme.palette.grey[600], 0.35)} transparent`,

        '&::-webkit-scrollbar': {
          width: 8,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme =>
            theme.palette.mode === 'dark'
              ? alpha(theme.palette.grey[500], 0.45)
              : alpha(theme.palette.grey[600], 0.35),
          borderRadius: 8,
        },
      }}
    >
      <Table
        size="small"
        stickyHeader
        sx={{
          width: '100%',
          borderCollapse: 'separate',
          borderSpacing: 0,
        }}
      >
        <TableHead>
          <TableRow
            sx={{
              '& th': {
                position: 'sticky',
                top: 0,
                zIndex: 2,

                backgroundColor: theme =>
                  theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : alpha(theme.palette.common.white, 0.06),

                color: 'text.secondary',
                fontSize: `${densidadeTabela.headerFontSize}rem`,
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                border: 'none',
                py: densidadeTabela.headerPy,
                px: densidadeTabela.cellPx,
                whiteSpace: 'nowrap',
              },
            }}
          >
            <TableCell align="center">QTD</TableCell>
            <TableCell>Descrição</TableCell>
            {/* Local/Ref/UN/Preço/Subtotal/Desc./Outros escondidas no celular (display,
                não removidas do JSX) — fica só QTD/Descrição/Total/Ações, o essencial
                pra caber sem precisar rolar a tabela na horizontal. */}
            <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Local</TableCell>
            <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Ref</TableCell>
            <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>UN</TableCell>
            <TableCell align="right" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Preço</TableCell>
            <TableCell align="right" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Subtotal</TableCell>
            <TableCell align="right" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Desc.</TableCell>
            <TableCell align="right" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Outros</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell align="right" sx={{ pr: 2 }}>
              <IconButton
                size="small"
                disabled={statuss === false ? isLoading : true}
                onClick={() => {
                  setIditens('novo');
                  setOpenNovo(true);
                }}
                sx={{
                  backgroundColor: 'action.hover',
                  color: 'primary.main',
                  padding: densidadeTabela.headerPy,
                  '&:hover': {
                    backgroundColor: 'action.selected',
                  },
                }}
              >
                <AddShoppingCartIcon fontSize="small" />
              </IconButton>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={11}
                align="center"
                sx={{
                  py: 15,
                  color: 'text.secondary',
                  fontStyle: 'italic',
                }}
              >
                Nenhum item adicionado
              </TableCell>
            </TableRow>
          ) : (
            [...rows]
              .sort((a, b) => (a.deletado === b.deletado ? 0 : a.deletado ? -1 : 1))
              .map(row => (
              <TableRow
                key={row.iditens}
                hover
                sx={{
                  transition: 'all 0.15s ease',

                  '& td': {
                    backgroundColor: theme =>
                      row.deletado
                        ? alpha(theme.palette.error.main, theme.palette.mode === 'light' ? 0.12 : 0.2)
                        : theme.palette.mode === 'light'
                          ? alpha(theme.palette.common.white, 0.9)
                          : alpha(theme.palette.background.paper, 0.85),

                    color: row.deletado ? 'error.main' : undefined,
                    border: 'none',
                    py: densidadeTabela.rowPy,
                    px: densidadeTabela.cellPx,
                    fontSize: `${densidadeTabela.rowFontSize}rem`,
                    whiteSpace: 'nowrap',
                  },

                  '&:hover td': {
                    backgroundColor: row.deletado ? undefined : 'action.hover',
                  },
                  '& td:first-of-type': {
                    borderTopLeftRadius: 8,
                    borderBottomLeftRadius: 8,
                  },
                  '& td:last-of-type': {
                    borderTopRightRadius: 8,
                    borderBottomRightRadius: 8,
                  },
                }}
              >
                <TableCell align="center">
                  {row.qtds.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })}
                </TableCell>

                <TableCell sx={{ fontWeight: 600, maxWidth: densidadeTabela.descricaoMaxWidth }}>
                  <Tooltip title={row.descricao || ''} arrow disableInteractive>
                    <Box
                      sx={{
                        display: 'block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {row.descricao}
                    </Box>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" sx={{ maxWidth: densidadeTabela.refMaxWidth, display: { xs: 'none', sm: 'table-cell' } }}>
                  <Tooltip title={row.localizado || ''} arrow disableInteractive>
                    <Box
                      sx={{
                        display: 'block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {row.localizado || '—'}
                    </Box>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" sx={{ maxWidth: densidadeTabela.refMaxWidth, display: { xs: 'none', sm: 'table-cell' } }}>
                  <Tooltip title={row.referencia || ''} arrow disableInteractive>
                    <Box
                      sx={{
                        display: 'block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {row.referencia}
                    </Box>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{row.un}</TableCell>

                <TableCell align="right" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                  {row.preco.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 4,
                  })}
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 700, color: 'success.main', display: { xs: 'none', sm: 'table-cell' } }}
                >
                  {(row.subtotal ?? 0).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 4,
                  })}
                </TableCell>
                <TableCell align="right" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                  {(row.desconto ?? 0).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 4,
                  })}
                </TableCell>
                <TableCell align="right" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                  {(row.voutros ?? 0).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 4,
                  })}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 700,
                    color: 'success.main',
                  }}
                >
                  {(row.total ?? 0).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 4,
                  })}
                </TableCell>
                <TableCell align="right" sx={{ pr: 2 }}>
                  <IconButton
                    size="small"
                    color="primary"
                    disabled={row.deletado || vendaBloqueada}
                    onClick={() => abrirEdicaoItem(row.iditens)}
                    sx={{ mr: 0.5, padding: densidadeTabela.rowPy }}
                  >
                    <Icon fontSize="small">edit</Icon>
                  </IconButton>

                  <IconButton
                    size="small"
                    disabled={row.deletado || vendaBloqueada}
                    sx={{
                      color: 'text.secondary',
                      padding: densidadeTabela.rowPy,
                      '&:hover': {
                        color: 'text.primary',
                      },
                    }}
                    onClick={() => handleDeleteItem(row.iditens)}
                  >
                    <Icon fontSize="small">delete</Icon>
                  </IconButton>
                </TableCell>
              </TableRow>
              ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <>
    <LayoutBaseDePaginaNfe
      barraDeFerramentas={
        <FerramentasDeDetalheVenda
          textoBotaoNovo='Nova Venda'
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoImpressao={id !== 'novo'}
          // Disponível assim que a venda existe salva (id !== 'novo') —
          // não depende de `statuss` (trava de edição, só liga depois da
          // 1ª parcela recebida) nem de `faturado` (nem sempre fica true
          // logo após um salvamento direto, fora do DialogFaturamento).
          // Escondido por enquanto, a pedido — pra voltar a mostrar, troque
          // por mostrarBotaoCarne={id !== 'novo'}.
          mostrarBotaoCarne={false}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoSalvar={statuss === false}
          mostrarBotaoApagar={id !== 'novo' && statuss === false}
          mostrarBotaoApagarCarregando={isLoading}
          mostrarBotaoCancelarVenda={faturamento === true && statuss === true && !vendaBloqueada}
          mostrarBotaoDevolucao={faturamento === true && statuss === true && !vendaBloqueada}
          mostrarBotaoAdicionarItem={statuss === false}
          mostrarBotaoVoltarCarregando={isLoading}
          mostrarBotaoNovoCarregando={isLoading}

          disableBotaoSalvar={statuss === false ? (isLoading || isSaving) : true}
          disableBotaoCancelarVenda={statuss === true && !vendaBloqueada ? (isLoading || isSaving) : true}
          disableBotaoSalvarEFechar={statuss === false ? (isLoading || isSaving) : true}
          disableBotaoApagar={statuss === false ? (isLoading || isSaving) : true}
          disableBotaoDevolucao={statuss === true && !vendaBloqueada ? (rowsidsDevolucao.length === 0 || itensAtivosCount === 0 || isLoading || isSaving) : true}
          disableBotaoAdicionarItem={statuss === false ? isLoading : true}


          aoClicarEmDevolucao={handlePrepararDevolucao}
          aoClicarEmCancelarVenda={() => handleDeleteDevolucao()}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmVoltar={() => navigate(voltarParaListagem)}
          aoClicarEmNovo={() => navigate('/venda/novo', { state: { from: voltarParaListagem } })}
          aoClicarEmImpressao={() => handleImpressao(id)}
          aoClicarEmCarne={() => handleImprimirCarne(id)}
          aoClicarEmApagar={() => handleDelete()}
          aoClicarEmAdicionarItem={() => {
            setIditens('novo');
            setOpenNovo(true);
          }}
          conteudoFinal={<SeletorModoBusca />}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} style={{ position: 'relative' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <CartaoFlutuanteCarregando
          open={carregandoVenda}
          message={id === 'novo' ? 'Carregando nova venda...' : 'Carregando venda...'}
          variant="skeleton"
        />
        <CartaoFlutuanteCarregando open={isSaving} message={mensagemBloqueio} />
        {vendaNaFila && (
          <Alert severity={vendaNaFila.status === 'erro' ? 'error' : 'warning'} sx={{ mx: 1, mt: 1 }}>
            {vendaNaFila.status === 'erro'
              ? `Esta venda não foi enviada ao servidor — ele recusou ao sincronizar: ${vendaNaFila.erro || 'motivo não informado'}. Corrija e salve para tentar enviar de novo.`
              : 'Esta venda ainda não foi enviada ao servidor — está salva neste computador e será enviada automaticamente quando a conexão voltar. Alterações feitas aqui também serão enviadas.'}
          </Alert>
        )}
        {vendaBloqueada && (
          <Alert severity="error" sx={{ mx: 1, mt: 1 }}>
            Esta venda foi {vendaStatus === 'cancelada' ? 'cancelada' : 'devolvida'}
            {dadosOriginais?.statusem ? ` em ${dayjs(dadosOriginais.statusem).format('DD/MM/YYYY [às] HH:mm')}` : ''}
            {' '}— não pode mais ser editada, apagada ou cancelada/devolvida de novo. Só visualização dos itens e dos dados da venda.
          </Alert>
        )}
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={tms === 'error' ? null : 900} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {msg}
          </Alert>
        </Snackbar>

        <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="error"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDelete}>
                  Nâo
                </Button>
              </>
            }
          >


            Tem certeza que deseja excluir este registro?
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirmCancelDevolucao} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="error"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDeleteDevolucao}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDeleteDevolucao}>
                  Nâo
                </Button>
              </>
            }
          >


            Tem certeza que deseja devolver esta venda?
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirmItem} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="error"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDeleteItem}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDeleteItem}>
                  Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este Item?
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirmFinalizar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button
                  color="inherit"
                  size="small"
                  autoFocus
                  onClick={handleConfirmFinalizar}
                >
                  Sim
                </Button>
                <Button
                  color="inherit"
                  size="small"
                  onClick={handleCancelFinalizar}
                >
                  Não
                </Button>
              </>
            }
          >
            Deseja realmente finalizar a venda?
          </Alert>
        </Snackbar>
        {/* Snackbar de confirmação para devolução */}
        <Snackbar open={openConfirmDevolucao} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"
            variant="standard"
            icon={false}
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              minWidth: 420,
              borderRadius: 2,
              border: '1px solid',
              borderColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,167,38,0.5)' : 'rgba(237,108,2,0.3)',
              bgcolor: (theme) => theme.palette.mode === 'dark' ? '#3a2c12' : '#FFF3E0',
              boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
              '& .MuiAlert-message': { width: '100%' },
            }}
            action={
              <>
                <Button
                  color="warning"
                  variant="contained"
                  size="small"
                  autoFocus
                  onClick={handleConfirmDevolucao}
                >
                  Sim
                </Button>
                <Button
                  color="inherit"
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    setOpenConfirmDevolucao(false);
                    setModoDevolucaoAtivo(false);
                  }}
                >
                  Não
                </Button>
              </>
            }
          >
            <Typography
              variant="subtitle1"
              fontWeight={700}
              sx={{ color: (theme) => theme.palette.mode === 'dark' ? '#FFE0B2' : '#E65100' }}
            >
              Deseja realmente realizar a devolução desta venda?
            </Typography>
            <Typography
              variant="body2"
              fontWeight={600}
              sx={{
                mt: 0.5,
                color: (theme) => theme.palette.mode === 'dark' ? '#FFF8E1' : '#4E342E',
              }}
            >
              Nº Venda: {dadosOriginais?.numero} | Total: R$ {Number(formRef.current?.getData()?.total || 0).toFixed(2)}
            </Typography>
          </Alert>
        </Snackbar>
        <Box
          margin={0.5}
          component={Paper}
          variant="outlined"
          sx={{
            borderRadius: 3,
            overflow: 'hidden',
          }}
        >
          {isLoading && <LinearProgress variant="indeterminate" />}

          <Grid container direction="column" padding={1} spacing={1}>
            {/* width/maxWidth explícitos (não só minWidth:0) — o container pai é
                direction="column", e nesse modo o MUI Grid não gera o max-width:100%
                que normalmente restringe um item xs={12} (confirmado: max-width
                computado ficava "none"); sem essa restrição o item cresce pra caber o
                conteúdo de dentro (os 8 campos lado a lado somavam ~560px), e o
                overflow só era escondido (não rolado) pelo Paper ancestral — por isso
                campos como "Numero" e "Total do Pedido" ficavam cortados fora da tela. */}
            <Grid item xs={12} sx={{ minWidth: 0, width: '100%', maxWidth: '100%' }}>
              <SectionBox>
                <Grid container spacing={1.5}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <AutoCompleteParceiro
                      isExternalLoading={statuss === false ? isLoading : true}
                      cpfs={handlecpf}
                      onParceiroBloqueado={handleParceiroBloqueado}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                    <AutoCompleteOperacoes
                      isExternalLoading={statuss === false ? isLoading : true}
                      disabled={(statuss === false ? isLoading : true) || verificandoEstoque}
                      faturamento={handleFaturamento}
                      tpag={handleTpag}
                      venda={handleVenda}
                      operacao={handleOperacao}
                      onIdOperacaoChange={handleIdOperacaoChange}
                      tipo={1}
                      apenasIds={OPERACOES_PERMITIDAS_VENDA}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                    <AutoCompletePlanoDeContas
                      isExternalLoading={statuss === false ? isLoading : true}
                    />
                  </Grid>
                </Grid>

                {!smDown && camposValores}
              </SectionBox>
            </Grid>

            {/* minWidth:0 — mesmo motivo do Grid item acima: sem isso a tabela de
                itens (larga, com 11 colunas) empurra este item pra além da largura
                disponível em telas estreitas, escondendo colunas em vez de deixar o
                TableContainer (que já tem overflowX:'auto') rolar. */}
            <Grid item xs={12} ref={tabelaItensRef} sx={{ minWidth: 0 }}>
              <SectionBox sx={{ p: { xs: 1, md: 1.5 } }}>
                {smDown && (
                  <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 1 }}>
                    Itens{itensAtivosCount > 0 ? ` (${itensAtivosCount})` : ''}
                  </Typography>
                )}
                {smDown ? itensCartoes : itensTable}
                {!smDown && camposVendedorObs}
              </SectionBox>
            </Grid>

            {smDown && (
              <Grid item xs={12} sx={{ minWidth: 0, width: '100%', maxWidth: '100%' }}>
                <SectionBox>
                  <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 1.5 }}>
                    Valores do pedido
                  </Typography>
                  {camposValores}
                </SectionBox>
              </Grid>
            )}

            {smDown && (
              <Grid item xs={12} sx={{ minWidth: 0, width: '100%', maxWidth: '100%' }}>
                <SectionBox>
                  {camposVendedorObs}
                </SectionBox>
              </Grid>
            )}

          </Grid>
          <DialogVendaEdit
              id={iditens}
              est={est}
              decimais={decimais}
              value={guuid}
              dados={dadositens}
              open={openEdit}
              onDados={handleItens}
              onClose={() => setOpenEdit(false)}
              status={dadositens?.status}
              modoDevolucao={modoDevolucaoAtivo}   // <-- nova prop
              idmov={id}                           // <-- nova prop
              onDevolucao={handleDevolucaoItem}    // <-- nova prop
            />
            <DialogVenda
              decimais={decimais}
              est={est}
              permitirSemEstoque={idOperacaoAtual === Environment.URL_IDORCAMENTO}
              open={openNovo}
              onClose={() => setOpenNovo(false)}
              onAdicionarItem={handleAdicionarItemNaVenda}
              itensAtuais={rows.filter(item => !item.deletado)}
            />

            {/* Itens sem estoque — aberto por handleIdOperacaoChange quando o operador tenta trocar
                a operação de Orçamento pra Venda à Vista/Prazo e algum item já lançado não tem
                estoque suficiente, e por handleSave como checagem final na hora de salvar. No
                caso da troca, a operação já foi revertida pro valor anterior antes desse dialog
                abrir — o operador precisa ajustar quantidade/remover o item (ou seguir em
                Orçamento) antes de conseguir trocar de novo. */}
            <Dialog open={itensSemEstoque !== null} onClose={() => setItensSemEstoque(null)} maxWidth="sm" fullWidth>
              <DialogTitle>Itens sem estoque suficiente</DialogTitle>
              <DialogContent dividers>
                {vendaNaFila ? (
                  <Alert severity="warning" sx={{ mb: 2 }}>
                    Esta venda feita offline <b>não foi enviada ao servidor</b>: os itens abaixo não têm
                    estoque suficiente no servidor. Ajuste a quantidade ou remova o item e salve de novo
                    para enviar. Enquanto isso, ela continua salva neste computador.
                  </Alert>
                ) : (
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Os itens abaixo não têm estoque suficiente. Ajuste a quantidade ou remova o item
                    para poder sair de Orçamento (ou salvar, se a venda já não estiver em Orçamento).
                  </Typography>
                )}
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Produto</TableCell>
                        <TableCell align="right">Solicitado</TableCell>
                        <TableCell align="right">Disponível</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(itensSemEstoque ?? []).map((item) => (
                        <TableRow key={item.idprodutos}>
                          <TableCell>{item.descricao}</TableCell>
                          <TableCell align="right">{item.qtdesolicitada}</TableCell>
                          <TableCell align="right">{item.estoquedisponivel}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </DialogContent>
              <DialogActions>
                <Button variant="contained" onClick={() => setItensSemEstoque(null)}>Entendi</Button>
              </DialogActions>
            </Dialog>
            <DialogFaturamento
              id={id}
              value={guuid}
              decimais={decimais}
              dados={cabecalho}
              dadosItens={rows.filter(item => !item.deletado)}
              open={openFaturamento}
              onClose={handleCloseFaturamento}
              status={statuss}
              operacao={operacao}
              iddeletados={rowsids}
            />
            <Dialog
              open={openPdfViewer}
              onClose={handleClosePdfViewer}
              maxWidth="lg"
              fullWidth
              PaperProps={{
                sx: {
                  position: 'relative',
                  height: '90vh',
                  maxHeight: '90vh',
                }
              }}
            >
              <CartaoFlutuanteCarregando
                open={isGeneratingPdf || isGeneratingCarne}
                message={isGeneratingCarne ? 'Gerando carnê...' : 'Carregando impressão...'}
              />
              <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PictureAsPdfIcon color="error" />
                  Visualização da Venda - Nº {cabecalho?.numero || id}
                </Typography>
                <Box>
                  <IconButton onClick={handleDownloadPdf} sx={{ mr: 1 }} title="Download">
                    <DownloadIcon />
                  </IconButton>
                  <IconButton onClick={handlePrintPdf} sx={{ mr: 1 }} title="Imprimir">
                    <PrintIcon />
                  </IconButton>
                  <IconButton onClick={handleClosePdfViewer}>
                    <CloseIcon />
                  </IconButton>
                </Box>
              </DialogTitle>
              <DialogContent dividers sx={{ p: 0, overflow: 'auto' }}>
                {pdfBlobUrl && (
                  <iframe
                    src={pdfBlobUrl}
                    style={{
                      width: '100%',
                      height: 'calc(90vh - 120px)',
                      border: 'none',
                    }}
                    title="Visualizador de PDF da Venda"
                  />
                )}
              </DialogContent>
            </Dialog>
        </Box>
      </VForm>
    </LayoutBaseDePaginaNfe>
    </>
  );
};